import * as React from "react";
import { Redirect } from "react-router-dom";
import { compose, pure, setDisplayName } from "recompose";
export var Render = function () { return React.createElement(Redirect, { to: "/" }); };
export function enhance() {
    return compose(pure, setDisplayName("RegisterVerificationSuccess"));
}
export var RegisterVerificationSuccess = enhance()(Render);
